import axios from "axios";
import { API_BASE } from "../../config/env";
import { CHECKOUT_BASE } from "../../config/env";

export const FETCH_GETDISTRICT_FULFILLED = "FETCH_GETDISTRICT_FULFILLED";
export const FETCH_GETDISTRICT_REJECTED = "FETCH_GETDISTRICT_REJECTED";
export const FETCH_GETDISTRICT_PENDING = "FETCH_GETDISTRICT_PENDING";
export const RESET_GETDISTRICT = "RESET_GETDISTRICT";

export function getDistrict(cityName) {
  const token = localStorage.getItem("accessToken");
  return (dispatch) => {
    dispatch({
      type: "FETCH_GETDISTRICT",
      payload: axios({
        method: "get",
        url: `${CHECKOUT_BASE}/gate/address/lookup/9/${cityName}`,
        headers: {
          Authorization: "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Content-Type": "application/json",
          "Cart-Type": "fast-checkout"
        },
      }).then((result) => result.data),
    });
  };
}

export function resetGetDistrict() {
  return (dispatch) => {
    dispatch({
      type: "RESET_GETDISTRICT",
    });
  };
}
